<template>
    <div class="user-data-container">
        <h2 class="title">
            The Podcasting World Awaits!
        </h2>
        <p class="description">
            {{ description }}
        </p>
        <slot />
    </div>
</template>
<script>
export default {
    props: {
        description: {
            type: String,
            required: true,
        },
    },
};
</script>
<style scoped lang="scss">
    @use './UserDataContainer.scss';
</style>
